module.exports = __webpack_public_path__ + "img/en.ff1ce28d.png";